import React, { useEffect, useState } from 'react';

import { Row, Col, Radio, Typography, Form } from 'antd';
const { Text } = Typography;

const ChoiceLine = ({ children, prefix, suffix, sizes }) => {
  const defaultSizes = {
    span: 24,
    offset: 0,
    prefix: {
      span: 11,
      offset: 0,
    },
    child: {
      span: 8,
      offset: 0,
    },
    suffix: {
      span: 5,
      offset: 0,
    },
  };

  const [columnSizes, setColumnSizes] = useState(defaultSizes);

  useEffect(() => {
    if (sizes) {
      setColumnSizes(sizes);
    }
  }, [sizes]);

  return (
    <Row span={columnSizes.span} offset={columnSizes.offset} className="recurrence-row">
      <Col span={columnSizes.prefix.span} offset={columnSizes.prefix.offset}>
        {prefix && !prefix.isRadioGroup ? (
          <Text className="recurrence-label recurrence-text">{prefix.label}</Text>
        ) : (
          // <Form.Item wrapperCol={{ offset: 0, span: 24 }}  rules={[{ required: true, message: 'Required' }]}>
          <Radio valuePropName="checked" value={prefix.value}>
            {prefix.label}
            {/* {prefix.label}-{prefix.value} */}
          </Radio>
          // </Form.Item>
        )}
      </Col>

      {children && (
        <Col
          offset={suffix ? columnSizes.child.offset : columnSizes.child.offset + columnSizes.suffix.offset}
          span={suffix ? columnSizes.child.span : columnSizes.child.span + columnSizes.suffix.span}
        >
          {children}
        </Col>
      )}

      {suffix && (
        <Col span={columnSizes.suffix.span} offset={columnSizes.suffix.offset}>
          <Text className="recurrence-text recurrence-additional-text"> {suffix}</Text>
        </Col>
      )}
    </Row>
  );
};
export default ChoiceLine;
